import { render, staticRenderFns } from "./auto.vue?vue&type=template&id=6a88208e&scoped=true"
import script from "./auto.vue?vue&type=script&lang=js"
export * from "./auto.vue?vue&type=script&lang=js"
import style0 from "./auto.vue?vue&type=style&index=0&id=6a88208e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a88208e",
  null
  
)

export default component.exports